import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { withRouter } from "react-router";
import { styleEndowment } from "../styleEndowment";
import { REQUIRED_MESSAGE } from "../../../constants";
import NextFormEndowment from "./nextFormEndowment";
import { defaultValueEndowment } from "../headers";
import { getMaestras } from "../../../actions/generation-contarct-action";
import { getActiveRegionals } from "../../../actions/regional-actions";
import {
  createEndowmentDelivery,
  getTypeEndowment,
} from "../../../actions/endowment-delivery-action";
import moment from "moment";

const NextGenerateEndowment = (props) => {
  const { message, setMessage, dataContract } = props;
  const classes = styleEndowment();
  const [maestras, setMaestras] = useState([]);
  const [regionals, setRegionals] = useState([]);
  const [sizePants, setSizePants] = useState([]);
  const [isChekedOther, setIsChekedOther] = useState(false);
  const [typeEndowment, setTypeEndowment] = useState([]);
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);
  const [hasShirt, setHasShirt] = useState(false);
  const [hasPijama, setHasPijama] = useState(false);
  const [hasSueter, setHasSueter] = useState(false);
  const [hasPants, setHasPants] = useState(false);
  const [hasShoes, setHasShoes] = useState(false);

  const schema = yup.object().shape({
    firstName: yup.string().nullable().notRequired(),
    secondName: yup.string().nullable().notRequired(),
    surname: yup.string().nullable().notRequired(),
    secondSurname: yup.string().nullable().notRequired(),
    gender: yup.string().nullable().required(REQUIRED_MESSAGE),
    regionalId: yup.string().nullable().required(REQUIRED_MESSAGE),
    deliverDate: yup
      .date()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(
        new Date(1899, 11, 31, 23, 59, 29),
        `Ingrese una fecha superior al año 1900`
      )
      .typeError("Ingrese un formato de fecha válido"),
    sizeShirt: hasShirt
      ? yup.string().nullable().required(REQUIRED_MESSAGE)
      : null,
    amountShirt: yup.string().nullable().notRequired(),
    pijamaSize: hasPijama
      ? yup.string().nullable().required(REQUIRED_MESSAGE)
      : null,
    pijamaAmount: yup.string().nullable().notRequired(),
    sueterSize: hasSueter
      ? yup.string().nullable().required(REQUIRED_MESSAGE)
      : null,
    sueterAmount: yup.string().nullable().notRequired(),
    pantsSize: hasPants
      ? yup.string().nullable().required(REQUIRED_MESSAGE)
      : null,
    pantsAmount: yup.string().nullable().notRequired(),
    shoesSize: hasShoes
      ? yup.string().nullable().required(REQUIRED_MESSAGE)
      : null,
    shoesAmount: yup.string().nullable().notRequired(),
    licenseAmount: yup.string().nullable().notRequired(),
    other: isChekedOther
      ? yup
          .string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(200, "Ingrese máximo 200 caracteres")
          .matches(/^([^0-9]*)$/, "Ingrese una descripción válida")
          .typeError("Ingrese una descripción válida")
      : yup
          .string()
          .nullable()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(200, "Ingrese máximo 200 caracteres")
          .matches(/^([^0-9]*)$/, "Ingrese una descripción válida")
          .typeError("Ingrese una descripción válida")
          .transform((v) => (v ? v : null)),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    initialStateForm: defaultValueEndowment,
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    setValue("firstName", dataContract?.employee?.firstName);
    setValue("secondName", dataContract?.employee?.secondName);
    setValue("surname", dataContract?.employee?.surname);
    setValue("secondSurname", dataContract?.employee?.secondSurname);
    setValue("regionalId", dataContract?.regional?.id);
  }, []);

  useEffect(() => {
    const getAllTypeEndowment = async () => {
      const response = await getTypeEndowment();
      setTypeEndowment(response?.data);
    };
    getAllTypeEndowment();
  }, []);

  useEffect(() => {
    const getListTeachers = async () => {
      const response = await getMaestras();
      setMaestras(response?.data?.maestras);
    };
    getListTeachers();
  }, []);

  useEffect(() => {
    const getRegional = async () => {
      const response = await getActiveRegionals();
      setRegionals(response?.data?.regionalList);
    };
    getRegional();
  }, []);

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const handleClickCloseSuccess = () => {
    setMessage({ ...message, open: false });
    navigateToEndowment();
  };

  const messageRequest = (msj, type, action) => {
    setIsDisabledBtn(false);
    setMessage({
      description: msj,
      textButtonSubmit: "Aceptar",
      handleClick: () => action(),
      type: type,
      oneButtons: true,
      open: true,
    });
  };

  const returnObjByEndowmentList = (typeEndow, size, amount, other) => {
    const newObj = typeEndowment?.find((x) => x?.code === typeEndow);
    if (other) {
      return {
        id: newObj.id,
        observation: other,
        size: "",
        amount: "",
      };
    } else {
      return {
        id: newObj.id,
        observation: "",
        size: size ? size : "",
        amount: amount,
      };
    }
  };

  const onSubmit = (data) => {
    const endowmentList = [];
    if ((data.sizeShirt, data.amountShirt)) {
      const adminShirt = returnObjByEndowmentList(
        "ADMINISTRATIVE_SHIRT",
        data.sizeShirt,
        data.amountShirt
      );
      endowmentList.push(adminShirt);
    }
    if ((data.pijamaSize, data.pijamaAmount)) {
      const pijama = returnObjByEndowmentList(
        "APERATIVE_PAJAMAS",
        data.pijamaSize,
        data.pijamaAmount
      );
      endowmentList.push(pijama);
    }
    if ((data.sueterSize, data.sueterAmount)) {
      const sueter = returnObjByEndowmentList(
        "SWEATER",
        data.sueterSize,
        data.sueterAmount
      );
      endowmentList.push(sueter);
    }
    if ((data.pantsSize, data.pantsAmount)) {
      const pants = returnObjByEndowmentList(
        "PANTS",
        data.pantsSize,
        data.pantsAmount
      );
      endowmentList.push(pants);
    }
    if ((data.shoesSize, data.shoesAmount)) {
      const shoes = returnObjByEndowmentList(
        "FOOTWEAR",
        data.shoesSize,
        data.shoesAmount
      );
      endowmentList.push(shoes);
    }
    if (data.licenseAmount) {
      const license = returnObjByEndowmentList(
        "CARD_AND_MEAT_HOLDER",
        "",
        data.licenseAmount
      );
      endowmentList.push(license);
    }
    if (data?.other) {
      const other = returnObjByEndowmentList("OTHERS", "", "", data?.other);
      endowmentList.push(other);
    }
    if (endowmentList?.length === 0) {
      const msj = "Debe seleccionar mínimo un elemento de dotación.";
      messageRequest(msj, "WARNING", handleClickClose);
      return;
    }
    objBySendToEndowment(data, endowmentList);
  };

  const objBySendToEndowment = (data, endowmentList) => {
    const newData = {
      employeeId: dataContract?.employee?.id,
      deliveryDate: moment(data?.deliverDate).format("DD/MM/YYYY"),
      typeEndowmentList: endowmentList,
    };
    setMessage({
      description: "¿Esta seguro que se desea guardar entrega de dotación?",
      textButtonSubmit: "Guardar",
      handleClick: () => sendEndowmentDelivery(newData),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  };

  const sendEndowmentDelivery = async (data) => {
    setIsDisabledBtn(true);
    setMessage({ ...message, open: false });
    const response = await createEndowmentDelivery(data);
    if (response?.status === 200 || response?.status === 201) {
      const msj =
        "El formato de entrega de dotación se ha generado de forma exitosa.";
      messageRequest(msj, "SUCCESS", handleClickCloseSuccess);
    } else if (response?.status > 399) {
      const msj = response?.data?.detail
        ? response?.data?.detail
        : "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
      messageRequest(msj, "WARNING", handleClickClose);
    } else {
      const msj =
        "Ocurrió un error procesando la solicitud, inténtelo nuevamente";
      messageRequest(msj, "WARNING", handleClickClose);
    }
  };

  const gender = watch("gender");

  useEffect(() => {
    if (gender === "FEMENINO") {
      setValue("pantsSize", "");
      setSizePants(maestras?.tallaNumerosFemenino);
    } else if (gender === "MASCULINO") {
      setValue("pantsSize", "");
      setSizePants(maestras?.tallaNumerosMasculino);
    } else if (gender === "INDETERMINADO") {
      setValue("pantsSize", "");
      const sizes = maestras?.tallaNumerosFemenino.concat(
        maestras?.tallaNumerosMasculino
      );
      setSizePants(sizes);
    } else {
      setValue("pantsSize", "");
      setSizePants(maestras?.tallaNumerosMasculino);
    }
  }, [gender]);

  const navigateToEndowment = () => {
    setIsDisabledBtn(false);
    props.history.push("/dashboard/endowment-delivery");
  };

  const handleChangeChecked = (e) => {
    setIsChekedOther(e.target.checked);
  };

  const onChangeClothes = (e, type) => {
    const { value } = e.target;
    if (value > 0) {
      if (type === "shirt") {
        setHasShirt(true);
      }
      if (type === "pijama") {
        setHasPijama(true);
      }
      if (type === "sueter") {
        setHasSueter(true);
      }
      if (type === "pants") {
        setHasPants(true);
      }
      if (type === "shoes") {
        setHasShoes(true);
      }
    } else {
      dontHaveEndowment();
    }
  };

  const dontHaveEndowment = () => {
    setHasShirt(false);
    setHasPijama(false);
    setHasPants(false);
    setHasSueter(false);
    setHasShoes(false);
  };

  return (
    <div className={classes.contNextEndowment}>
      <NextFormEndowment
        register={register}
        control={control}
        errors={errors}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        maestras={maestras}
        regionals={regionals}
        sizePants={sizePants}
        navigateToEndowment={navigateToEndowment}
        handleChangeChecked={handleChangeChecked}
        isChekedOther={isChekedOther}
        isDisabledBtn={isDisabledBtn}
        onChangeClothes={onChangeClothes}
      />
    </div>
  );
};

export default withRouter(NextGenerateEndowment);
